"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$primar, _theme$palette2, _theme$palette2$grey;

  return {
    checkout: {
      "& .mco-shop-checkout__wrapper": _defineProperty({
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(4),
        "&::after": {
          clear: "both",
          content: "''",
          display: "block"
        }
      }, theme.breakpoints.up(1200), {
        display: "block"
      }),
      "& .mco-shop-checkout__right-column": _defineProperty({
        order: 2,
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3)
      }, theme.breakpoints.up(1200), {
        float: "right",
        marginBottom: 0,
        marginTop: 0,
        position: "sticky",
        top: 0,
        width: 427
      }),
      "& .mco-shop-checkout__content": _defineProperty({
        order: 1
      }, theme.breakpoints.up(1200), {
        marginRight: 451,
        "& .mco-shop-cart-item__image": {
          maxWidth: 120
        },
        "& .mco-shop-cart-item__content": {
          display: "flex",
          flexDirection: "row",
          paddingRight: 60
        },
        "& .mco-shop-cart-item__details": {
          display: "flex",
          flex: 1,
          flexDirection: "column",
          marginRight: theme.spacing(4)
        },
        "& .mco-shop-cart-item__wrapper": {
          alignItems: "center",
          marginTop: 0,
          paddingTop: 0
        },
        "& .mco-shop-cart-item__availability": {
          marginTop: "auto"
        },
        "& .mco-shop-cart-item__price": {
          minWidth: 160
        },
        "& .mco-shop-cart-item__delete-button": {
          top: "50%",
          transform: "translate(0, -50%)"
        }
      }),
      "& .mco-shop-checkout__price-wrapper": {
        background: (0, _colorManipulator.alpha)((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$primar = _theme$palette.primary) === null || _theme$palette$primar === void 0 ? void 0 : _theme$palette$primar.main, 0.05),
        padding: theme.spacing(3)
      },
      "& .mco-shop-checkout__price": {
        borderBottom: "1px solid ".concat((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$grey = _theme$palette2.grey) === null || _theme$palette2$grey === void 0 ? void 0 : _theme$palette2$grey[100]),
        paddingBottom: theme.spacing(2)
      },
      "& .mco-shop-checkout__total-price": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-checkout__button": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-cart-buttons": {
        marginTop: theme.spacing(4),
        "& button": {
          marginLeft: "auto"
        }
      }
    },
    shippingProviders: {
      marginBottom: theme.spacing(4)
    }
  };
});
var _default = styles;
exports.default = _default;